export const clientThemeLVMH = {
    mainLayout: {
        backgroundColor: '#f4f4f5',
        hover: {
            backgroundColor: '#1A4D66',
        },
    },
    topBar: {
        backgroundColor: '#131526',
        contrastText: '#d9d9d9',
        contrastLinkText: '#d9d9d9',
        userIcon: '#d9d9d9',
        brandLogo: {
            maxWidth: '120px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#d9d9d9',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#131526',
        darkBackgroundColor: '#1c1e37',
        sideMenuActive: {
            backgroundColor: '#0a3455',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '#1c1e37',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#335C92',
        stroke: '#335C92',
        lineCharts: {
            stroke: '#335C92',
            fill: '#335C92',
        },
        areaCharts: {
            gradient: {
                start: '#335C92',
                stop: '#335C92',
            },
            stroke: '#335C92',
            fill: '#335C92',
            chargebacksByPostDateChart: {
                stroke: '#335C92',
                fill: '#335C92',
            },
            newAlertsByDateChart: [
                {
                    stroke: '#335C92',
                    fill: '#335C9220',
                },
                {
                    stroke: '#65989f',
                    fill: '#65989f20',
                },
                {
                    stroke: '#708c69',
                    fill: '#708c6920',
                },
                {
                    stroke: '#acbc8f',
                    fill: '#acbc8f20',
                },
                {
                    stroke: '#723b38',
                    fill: '#723b3820',
                },
                {
                    stroke: '#bf5d50',
                    fill: '#bf5d5020',
                },
                {
                    stroke: '#e89e78',
                    fill: '#e89e7820',
                },
                {
                    stroke: '#e4b667',
                    fill: '#e4b66720',
                },
            ],
        },
        barCharts: {
            fill: '#335C92',
            byPlatformBarChart: { fill: '#335C92' },
            byBinBarChart: { fill: '#335C92' },
            ertsByRevenueChart: {
                bar1Fill: '#335C92',
                bar2Fill: '#bf5d50',
            },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#335C92',
                lineColor: '#708c69',
            },
        },
        pieCharts: {
            defaultPieChart: [
                '#335C92',
                '#708c69',
                '#acbc8f',
                '#bf5d50',
                '#e4b667',
            ],
            dashboardPieChart: [
                '#335C92',
                '#708c69',
                '#acbc8f',
                '#bf5d50',
                '#e4b667',
            ],
            byReasonCodePieChart: [
                '#335C92',
                '#708c69',
                '#acbc8f',
                '#bf5d50',
                '#e4b667',
            ],
            byReasonCodeDistributionPieChart: [
                '#335C92',
                '#708c69',
                '#acbc8f',
                '#bf5d50',
                '#e4b667',
            ],
            byCardTypePieChart: [
                '#335C92',
                '#708c69',
                '#acbc8f',
                '#bf5d50',
                '#e4b667',
            ],
            byLocationTypePieChart: [
                '#335C92',
                '#708c69',
                '#acbc8f',
                '#bf5d50',
                '#e4b667',
            ],
            byPlatformPerCardTypePieChart: [
                '#335C92',
                '#708c69',
                '#acbc8f',
                '#bf5d50',
                '#e4b667',
            ],
            byStatusPieChart: [],
            byWinLossPieChart: [],
        },
        radialBarCharts: {
            fill: '#335C92',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#cb2022`,
        backgroundColor: `rgba(203,32,34,.1)`,
        labelColor: `#cb2022`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#0a3455',
        saveAndContinueBtn: {
            margin: '0px',
            fontWeight: 700,
            textTransform: 'capitalize',
            backgroundColor: '#0a3455',

            '&:hover': {
                backgroundColor: '#0a3455',
            },
        },
        submittingColor: '#3399CC',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '7px 8px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#27272a',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e4e4e7',
    },
    searchBar: {
        padding: '6px',
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#e4e4e7',
                color: '#27272a',
                '&:hover': {
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 600,
                padding: '4px 10px',
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#71717a',
                backgroundColor: '#d4d4d8',
                '&:hover': {
                    color: '#71717a',
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#31B98E',
                '&:hover': {
                    backgroundColor: '#23826F',
                },
            },
        },
        activeStateButton: {
            color: '#FFFFFF',
            backgroundColor: '#52525b',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#0a3455',
    primaryLight: '#0a3455',
    primary: '#0a3455',
    primaryDark: '#0a3455',
    secondaryLight: '#0a3455',
    secondary: '#0a3455',
    secondaryDark: '#0a3455',
    hyperlink: '#0a3455',
    textField: '#0a3455',
    switch: '#0a3455',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Roboto', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Roboto',
            fallback:
                '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '14px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '14px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '14px',
        },
        body1: {
            fontSize: '14px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '14px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '14px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '14px',
                color: '#52525b',
            },
            tableExpandable: {
                fontSize: '14px',
            },
        },
    },
    shadows: {
        brandShadowLight: 'rgb(10, 52, 85,.4)',
    },
}
